<div id="bar"></div>
<div *ngFor="let p of products; index as i" class="bar-circle" [class.selected]="i === selected" [style.top.%]="calculateBarTop(i)"></div>